import React, { useMemo, useEffect, useState } from "react";
import Select from "react-select";
import { getPaymentCategories } from "common/services/payments.service";
import { normalize } from "common/lib/normalize";

type FilterProps = {
  onChange: (value: any) => void;
  value: any;
};
const PaymentCategoryFilter = ({ onChange, value }: FilterProps) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor: "#ced4da",
      "&:hover": {
        borderColor: "#ced4da",
      },
    }),
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getPaymentCategories({
          pagination: {
            page: 1,
            pageSize: 10000,
          },
          filters: {},
          fields: ["id", "name"],
        });

        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: el?.name,
      };
    });
  }, [data]);

  return (
    <Select
      name="paymentCategory"
      id="paymentCategory"
      isSearchable
      isClearable
      placeholder="Select payment category"
      onChange={onChange}
      options={options}
      value={value}
      styles={customSelectStyles}
      loading={loading}
    />
  );
};

export default PaymentCategoryFilter;
